import * as actionTypes from "./actionTypes";
import StoricoConfigurazioniApiClient from "../../api/storicoConfigurazioniApiClient";
import saveFileFromBlob from "../../util/fileUtils";
import {
  toastError,
  toastSuccess,
  toastWarning,
} from "../../component/shared/toast/Toast";
import { store } from "../store";

export const fetchStoricoConfigurazioni = (filter, sortBy, page, size) => {
  const integrationId =
    store.getState().customersReducer.selectedCustomer.integrationId;
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
      key: "loading",
      value: true,
    });
    StoricoConfigurazioniApiClient.getStoricoConfigurazioniTableData(
      buildParams(filter, sortBy, page, size, integrationId)
    )
      .then((res) => {
        dispatch({
          type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
          key: "data",
          value: res.data.result.storicoConfigurazioniList,
        });
        dispatch({
          type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
          key: "totalNumRecords",
          value: res.data.result.totalNumRecords,
        });
      })
      .catch((err) => console.log(err.response.data))
      .finally(() => {
        dispatch({
          type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
          key: "loading",
          value: false,
        });
      });
  };
};

export const exportStoricoConfigurazioniCsv = (filter, sortBy, page, size) => {
  const integrationId =
    store.getState().customersReducer.selectedCustomer.integrationId;
  return (dispatch) => {
    dispatch({
      type: actionTypes.EXPORT_STORICO_LOADING,
      value: true,
    });
    StoricoConfigurazioniApiClient.exportCsv(buildParams(filter, sortBy, page, size, integrationId))
      .then((res) => {
        saveFileFromBlob(res);
        toastSuccess("Storico configurazioni scaricati in CSV");
      })
      .catch((err) => {
        console.error(err.response.data);
        toastError("Errore durante il download del file CSV");
      })
      .finally(() => {
        dispatch({
          type: actionTypes.EXPORT_STORICO_LOADING,
          value: false,
        });
      });
  };
};

export const exportStoricoConfigurazioniXls = (filter, sortBy, page, size) => {
  const integrationId =
    store.getState().customersReducer.selectedCustomer.integrationId;
  return (dispatch) => {
    dispatch({
      type: actionTypes.EXPORT_STORICO_LOADING,
      value: true,
    });
    StoricoConfigurazioniApiClient.exportXls(buildParams(filter, sortBy, page, size, integrationId))
      .then((res) => {
        if (res.status === 204) {
          toastWarning("Nessun storico configurazioni trovato.");
          return;
        }
        toastSuccess("Storico configurazioni caricati in Excel");
        saveFileFromBlob(res);
      })
      .catch((err) => {
        console.error(err.response.data);
        toastError("Errore durante il download del file Excel");
      })
      .finally(() => {
        dispatch({
          type: actionTypes.EXPORT_STORICO_LOADING,
          value: false,
        });
      });
  };
};

export const getStoricoConfigurazioniFilterData = (customerId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_STORICO_FILTER_DATA,
      key: "loading",
      value: true,
    });
    StoricoConfigurazioniApiClient.getStoricoConfigurazioniFilterData(
      customerId
    )
      .then((res) => {
        dispatch({
          type: actionTypes.GET_STORICO_FILTER_DATA,
          key: "data",
          value: res.data.result,
        });
      })
      .catch((err) => {
        console.error(err.response.data);
      })
      .finally(() => {
        dispatch({
          type: actionTypes.GET_STORICO_FILTER_DATA,
          value: false,
          key: "loading",
        });
      });
  };
};

export const clearStoricoTableData = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
      key: "data",
      value: [],
    });
    dispatch({
      type: actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING,
      key: "totalNumRecords",
      value: 0,
    });
  }
}

const buildParams = (filter, orderBy, page, size, integrationId) => {
  return {
    integrationId: integrationId,
    numeroSpeciale: filter.numeroSpeciale,
    tipoRichiesta: filter.tipoRichiesta,
    portalUser: filter.portalUser,
    dateFrom: filter.dateFrom,
    dateTo: filter.dateTo,
    orderBy: orderBy,
    page: page,
    size: size
  };
};
